import { Slice } from "store/utils/slice";
import { ROOT } from "store/utils/types";
import type { EntitiesStateWithMeta } from "store/utils/types";

import { baseWidgets } from "./baseWidgets";
import type { WidgetCardsCategorized } from "./baseWidgets";

interface WidgetsState {
  widgets: WidgetCardsCategorized;
}

export default new Slice<
  EntitiesStateWithMeta<WidgetsState, Record<string, never>>
>("availableWidgets", {
  entities: { [ROOT]: { widgets: baseWidgets } },
  loading: {},
  errors: {},
  meta: {},
});
